import { airbrake } from "./configureAirbrake";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { App } from "./App";

let startApp = function() {
  ReactDOM.render(<App />, document.getElementById("root"));
};
startApp = airbrake.wrap(startApp);
startApp();
